import React from 'react';
import SEO from '../components/ui/SEO';
import Button from '../components/ui/Button';
import { Mail, Clock, MapPin } from 'lucide-react';
const contactSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Instruct Dr Syed',
  description: 'Send a case type, jurisdiction and deadline to instruct an independent psychiatric expert witness for proceedings in England and Wales.',
  mainEntity: {
    '@type': 'Organization',
    name: 'Medicolegal Psychiatry',
    url: 'https://medicolegal-psychiatry.co.uk',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'instructions and enquiries',
      email: 'enquiries@medicolegal-psychiatry.co.uk',
      availableLanguage: ['English', 'Urdu', 'Hindi', 'Punjabi'],
      areaServed: ['England', 'Wales']
    },
    openingHoursSpecification: [{
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '17:00'
    }, {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Saturday',
      opens: '09:00',
      closes: '13:00'
    }]
  }
};
export default function Contact() {
  return <main className="min-h-screen bg-white" data-id="element-484" data-mp="1e8accz7b8l0n">
      <SEO title="Instruct Dr Syed | Medicolegal Psychiatry" description="Instruct an independent psychiatric expert witness for proceedings in England and Wales. Send your case type, jurisdiction and deadline." path="/contact" keywords={['instruct a psychiatric expert witness', 'psychiatric expert witness enquiry', 'medico-legal psychiatry contact']} imageAlt="Instruct Dr Imtiaz Syed, Independent Psychiatric Expert Witness" schema={contactSchema} data-id="element-485" data-mp="1j6twcu2cfmqd" />
      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-486" data-mp="26yijzx47zn0z">
        <div className="container mx-auto px-4" data-id="element-487" data-mp="2bu7rcmmhe87u">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-center" data-id="element-488" data-mp="1m7detmpyrvk4">
            Contact Medico-Legal Psychiatry
          </h1>
          <p className="text-xl max-w-3xl mx-auto text-center" data-id="element-489" data-mp="1h7qwwzz6xr4z">
            Get in Touch for Expert Psychiatric Assessments
          </p>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-12" data-id="element-490" data-mp="1r6zpppibkzpr">
        <div className="container mx-auto px-4" data-id="element-491" data-mp="1r4ly5qmum5my">
          <div className="max-w-3xl mx-auto mb-12" data-id="element-492" data-mp="13hx7affv32u7">
            <p className="text-slate-dark text-lg mb-6" data-id="element-493" data-mp="yhssquyiki6m">
              We've made it easy for you to reach us. Choose the method that
              works best for you:
            </p>
            <ul className="space-y-6 mb-8" data-id="element-494" data-mp="1d8rxtw054olg">
              <li className="flex items-start" data-id="element-495" data-mp="18fozzbobyszg">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-496" data-mp="18dvs5t1ze2pv">
                  <Mail className="h-6 w-6" data-id="element-497" data-mp="kotcgqqwqjy0" />
                </div>
                <div data-id="element-498" data-mp="fs2yc8ynxyf8">
                  {/* h2, not h3: these contact methods are the first headings
                      after the page H1. Classes unchanged. */}
                  <h2 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-499" data-mp="2rctsspurxmlj">
                    Direct Email
                  </h2>
                  <p className="text-slate-dark mb-2" data-id="element-500" data-mp="2hh8js7rafm2a">
                    For detailed inquiries and to send instruction bundles, you
                    can email us directly:
                  </p>
                  <a href="mailto:enquiries@medicolegal-psychiatry.co.uk" className="text-primary hover:text-secondary transition-colors" data-id="element-501" data-mp="3a4utlxr3zmxl">
                    enquiries@medicolegal-psychiatry.co.uk
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-502" data-mp="354qcc5idmo6b">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-503" data-mp="1ppatwx4nikun">
                  <Clock className="h-6 w-6" data-id="element-504" data-mp="1prdu29zipud3" />
                </div>
                <div data-id="element-505" data-mp="1trnwxds0k4nq">
                  <h2 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-506" data-mp="1torzdqk2vhzt">
                    Our Hours
                  </h2>
                  <p className="text-slate-dark mb-2" data-id="element-507" data-mp="257khsk6u9o29">
                    Our team is available to process your messages and
                    coordinate discussions during:
                  </p>
                  <ul className="space-y-1 text-slate-dark" data-id="element-508" data-mp="1v9eimacf2w13">
                    <li data-id="element-509" data-mp="1vaxvdqyv6oy4">
                      Monday to Friday: 9:00 AM to 5:00 PM (GMT/BST) (excluding
                      Bank Holidays)
                    </li>
                    <li data-id="element-510" data-mp="2nytu117zuqxj">Saturdays: 9:00 AM to 1:00 PM (GMT/BST)</li>
                    <li data-id="element-511" data-mp="2iyfjncix74wc">Sundays: Closed</li>
                  </ul>
                  <p className="text-slate mt-2" data-id="element-512" data-mp="2j0saygakirm2">
                    Messages received outside of these hours will be addressed
                    promptly on the next working day.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-513" data-mp="13hfbqsxqm8to">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-514" data-mp="13gnl7wizz1a9">
                  <MapPin className="h-6 w-6" data-id="element-515" data-mp="3f6loazuh3gvh" />
                </div>
                <div data-id="element-516" data-mp="3j6du54shf8x5">
                  <h2 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-517" data-mp="3j7ozva5hmqqw">
                    Accessibility and Flexibility
                  </h2>
                  <p className="text-slate-dark" data-id="element-518" data-mp="3swp4b92reech">
                    Dr. Syed offers exceptional flexibility to accommodate your
                    needs and those of your clients. He can conduct remote
                    assessments across all regions of the UK. For your
                    convenience, in-person assessments can also be arranged, and
                    Dr. Syed is available for prison visits, care home visits,
                    and court attendance when required.
                  </p>
                </div>
              </li>
            </ul>
            <p className="text-slate-dark text-lg mb-6" data-id="element-519" data-mp="2cka21wliynrb">
              We look forward to partnering with you to provide the expert
              psychiatric insights your cases require.
            </p>
          </div>
          {/* Email Contact Section (Replacing Form) */}
          <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8 text-center" data-id="element-520" data-mp="3fuo3717xj5jl">
            <h2 className="text-2xl font-serif font-bold text-primary mb-6" data-id="element-521" data-mp="3tu7356ql7akt">
              Contact Us Directly
            </h2>
            <div className="mb-8" data-id="element-522" data-mp="3osq0p6sgfg24">
              <p className="text-slate-dark text-lg mb-4" data-id="element-523" data-mp="7lnxwfpceg2y">
                For all inquiries regarding medico-legal assessments, expert
                witness services, or to discuss your specific case requirements,
                please email us directly. We aim to respond to all messages
                within 24 hours during business days.
              </p>
              <p className="text-slate-dark text-lg mb-6" data-id="element-524" data-mp="ceqsmr5uvvkq">
                Please include your name, contact information, and a brief
                description of your inquiry to help us assist you more
                efficiently.
              </p>
            </div>
            <div className="flex justify-center" data-id="element-525" data-mp="150fetv428dkn">
              <Button variant="primary" size="lg" href="mailto:enquiries@medicolegal-psychiatry.co.uk?subject=Medico-Legal%20Inquiry" data-id="element-526" data-mp="19y74sjl59pm7">
                <Mail className="h-5 w-5 mr-2" data-id="element-527" data-mp="10015m9qq2xl1" />
                Email Us Now
              </Button>
            </div>
          </div>
        </div>
      </section>
    </main>;
}